<template>
  <h1 class="heading">
    {{ value }}
  </h1>
</template>

<script>
export default {
  name: "Heading",
  props: {
    value: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.heading {
  color: theme-color("body");
  display: block;
  font-size: px-to-rem(26px);
  text-align: center;
  width: 100%;

  @include if-tablet {
    font-size: px-to-rem(42px);
  }
}
</style>
